/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtounlistevent3Inputs */

const en_failedtounlistevent3 = /** @type {(inputs: Failedtounlistevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to unlist event`)
};

const de_failedtounlistevent3 = /** @type {(inputs: Failedtounlistevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event konnte nicht aus der Liste genommen werden`)
};

/**
* | output |
* | --- |
* | "Failed to unlist event" |
*
* @param {Failedtounlistevent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtounlistevent3 = /** @type {((inputs?: Failedtounlistevent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtounlistevent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtounlistevent3(inputs)
	return de_failedtounlistevent3(inputs)
});
export { failedtounlistevent3 as "failedToUnlistEvent" }